window.pushToDataLayer = function(obj) {
    console.log('window.google_tag_manager:', window.google_tag_manager);
    console.log('typeof window.dataLayer.push:', typeof window.dataLayer?.push);

    if(window.google_tag_manager && typeof window.dataLayer?.push === "function") {
        dataLayer.push(obj);
        return;
    }

    console.log('DataLayer Event:', obj);
    if (typeof obj.eventCallback === 'function') {
        obj.eventCallback();
    }
};

window.sendToDataLayer = function(eventName, formfields = null, value = null, callbackAfterGtm = null) {
    let obj = {
        event: eventName,
        eventCallback: callbackAfterGtm,
        eventTimeout: 2000
    };
    if (formfields) obj.formfields = formfields;
    if (value) obj.value = value;

    window.pushToDataLayer(obj);
}

window.sendDisplayClickToDataLayer = function(card, source = 'search', detail = null) {

    let items = [];

    if (!card.id) {
        console.warn('Card ID is missing:', card);
        return;
    }

    items.push({
        item_id: 'display_' + card.id,
        item_name: card.name,
        item_category: card.category ?? null,
        location_id: card.province ?? null
    });

    let obj = {
        event: 'click_item',
        click_source: source,
        click_source_detail: detail,
        eventCallback: () => {
            window.location = card.url;
        },
        eventTimeout: 2000,
        items: items
    };

    window.pushToDataLayer(obj);
}

window.sendSearchToDataLayer = function(category = null, province = null, callbackAfterGtm = null) {
    let obj = {
        event: 'click_search',
        value: category?.name ?? null,
        event_label: province?.name ?? null,
        eventCallback: callbackAfterGtm,
        eventTimeout: 2000
    };
    window.pushToDataLayer(obj);
}

window.sendQuotationToDataLayer = function(source = 'card-generic', callbackAfterGtm = null) {
    let obj = {
        event: 'generic_cta_preventivo_gratis',
        value: source,
        eventCallback: callbackAfterGtm,
        eventTimeout: 2000
    };

    window.pushToDataLayer(obj);
}

window.sendCloseToDataLayer = function(value = null, callbackAfterGtm = null) {
    let obj = {
        event: 'modal_generic_cta_close',
        value: value,
        eventCallback: callbackAfterGtm,
        eventTimeout: 2000
    };

    window.pushToDataLayer(obj);
}
